import { Data, Response } from '@dimandzhi/graphql';
import { currentMethodName } from 'app/current-method-name';
import { GraphQL } from 'app/graphql';
import { environment as env } from 'environments/environment';
import _ from 'lodash';
import { first, map } from 'rxjs/operators';


const gqlType = GraphQL.Channel;
type gqlType = GraphQL.Channel;
const ModelName = gqlType.getModelName();

export class Channels extends gqlType.createServiceBaseConstructor() {
  updateChannelExportEveryHourValue(id: number, exportEveryHourValue: boolean) {
    return this.http.post<Response>(`${env.graphqlUser}/${currentMethodName()}`, `
      mutation {
        ${ModelName} {
          update(values:[{
            id: ${id}
            exportEveryHour: ${exportEveryHourValue}
          }])
        }
      }`
    ).pipe(
      first(),
      Data.fromResp,
      map(data => {
        const result = _.get(data.get(), `${ModelName}.update`) as (number[] | undefined);
        if (result === undefined) {
          throw new Error(`result is undefined`);
        }
        return result;
      }),
      map(rowsAffected => {
        if (!_.isNumber(rowsAffected)) {
          throw new Error(`rowsAffected is not a number: ${typeof rowsAffected} ${rowsAffected}`);
        }
        if (rowsAffected > 0) {
          //this.channels.next(this.channels.value.concat(channel));
        }
        return rowsAffected;
      }),
    );
  }
}

